import {Component} from '@angular/core';

@Component({template: ''})
export class NoOpComponent {
    // This is for a workaround for the issue https://github.com/angular/angular/issues/18605
}